import React, { useState } from "react";
import { Col, Row, Menu, Dropdown, Button, Popover, List } from "antd";
import "./PrivateLibrary.css";
import { NavLink } from "react-router-dom";
const list = [
  {
    itemType: "workFlow",
    icon: "fa-brands fa-nfc-symbol",
    workNumber: 0,
    title: "Blank WorkFlow",
    color: "#645CBB",
  },
  {
    itemType: "workFlow",
    icon: "fa-brands fa-nfc-symbol",
    workNumber: 122,
    title: "Blank WorkFlow",
    color: "#645CBB",
  },
];
function PrivateLibrary() {
  const [listData, setListData] = useState(list);

  let key;

  const CreateNewItem = (key) => {
    if (key === "folder") {
      setListData([
        ...listData,
        {
          itemType: "folder",
          icon: "fa-solid fa-folder",
          title: "untitled",
          color: "#687980",
        },
      ]);
    }
    if (key === "flow") {
      setListData([
        ...listData,
        {
          itemType: "workFlow",
          icon: "fa-brands fa-nfc-symbol",
          title: "untitled",
          color: "#645CBB",
        },
      ]);
    }
    if (key === "page") {
      setListData([
        ...listData,
        {
          itemType: "page",
          icon: "fa-solid fa-file-lines",
          title: "untitled",
          color: "#3b921e",
        },
      ]);
    }
  };

  const content = (
    <Row className="popover-container">
      <Col
        span={24}
        className="add-col"
        onClick={() => CreateNewItem((key = "flow"))}
      >
        <Row gutter={[8, 0]}>
          <Col>
            <i
              className="fa-brands fa-nfc-symbol"
              style={{ color: "#645CBB" }}
            ></i>
          </Col>
          <Col>
            <strong>Workflow</strong>
            <p className="silver-text">Build a new workflow</p>
          </Col>
        </Row>
      </Col>
      <Col
        span={24}
        className="add-col"
        onClick={() => CreateNewItem((key = "flow"))}
      >
        <Row gutter={[8, 0]}>
          <Col>
            <i
              className="fa-brands fa-nfc-symbol"
              style={{ color: "#645CBB" }}
            ></i>
          </Col>
          <Col>
            <strong>Workflow from Template</strong>
            <p className="silver-text">Explore our Template Gallery</p>
          </Col>
        </Row>
      </Col>
      <Col
        span={24}
        className="add-col"
        onClick={() => CreateNewItem((key = "page"))}
      >
        <Row gutter={[8, 0]}>
          <Col>
            <i
              className="fa-solid fa-file-lines"
              style={{ color: "#3b921e" }}
            ></i>
          </Col>
          <Col>
            <strong>Page</strong>
            <p className="silver-text">Document Team Knowledge</p>
          </Col>
        </Row>
      </Col>
      <Col
        span={24}
        className="add-col"
        onClick={() => CreateNewItem((key = "folder"))}
      >
        <Row gutter={[8, 0]}>
          <Col>
            <i className="fa-solid fa-folder" style={{ color: "#687980" }}></i>
          </Col>
          <Col>
            <strong>Folder</strong>
            <p className="silver-text">Organize Workflows and Pages</p>
          </Col>
        </Row>
      </Col>
    </Row>
  );
  const menu = (
    <Menu
      style={{ width: "200px", height: "300px", overflow: "scroll" }}
      aria-label="Options"
    >
      <Menu.Item key="1" icon={<i className="fa-solid fa-play"></i>}>
        Run Workflow
      </Menu.Item>
      <Menu.Item key="2" icon={<i className="fa-solid fa-pen"></i>}>
        Edit
      </Menu.Item>
      <Menu.Item key="3" icon={<i className="fa-solid fa-table-list"></i>}>
        View Workflow runs
      </Menu.Item>
      <Menu.Item key="4" icon={<i className="fa-solid fa-play"></i>}>
        Workflow run link
      </Menu.Item>
      <Menu.Item key="5" icon={<i className="fa-solid fa-forward"></i>}>
        Run multiple
      </Menu.Item>
      <Menu.Item key="6" icon={<i className="fa-solid fa-clock"></i>}>
        Schedule Workflow
      </Menu.Item>
      <Menu.Item key="7" icon={<i className="fa-solid fa-clock-rotate-left"></i>}>
        Activity
      </Menu.Item>
      <Menu.Item key="8" icon={<i className="fa-solid fa-eye"></i>}>
        Subscribe
      </Menu.Item>
      <Menu.Item key="9" icon={<i className="fa-solid fa-tag"></i>}>
        Manage Tags
      </Menu.Item>
      <Menu.Item key="10" icon={<i className="fa-solid fa-arrow-right"></i>}>
        Move
      </Menu.Item>
      <Menu.Item key="11" icon={<i className="fa-solid fa-copy"></i>}>
        Duplicate
      </Menu.Item>
      <Menu.Item
        key="12"
        icon={<i className="fa-solid fa-arrow-down-to-line"></i>}
      >
        Export
      </Menu.Item>
      <Menu.Item key="13" icon={<i className="fa-solid fa-arrow-down-to-line"></i>}>
        Print
      </Menu.Item>
      <Menu.Item key="14" icon={<i className="fa-solid fa-box-archive"></i>}>
        Archive
      </Menu.Item>
      <Menu.Item key="15" icon={<i className="fa-solid fa-trash-can"></i>}>
        Delete
      </Menu.Item>
    </Menu>
  );

  const settingMenu = (
    <Menu style={{ width: "200px" }} aria-label="Options">
      <Menu.Item key="13">
        <Row gutter={[10, 12]}>
          <Col>
            <i className="fa-solid fa-folder-plus"></i>
          </Col>
          <Col>New Folder</Col>
        </Row>
      </Menu.Item>
      <Menu.Item key="14">
        <Row gutter={[10, 12]}>
          <Col>
            <i className="fa-regular fa-eye-slash"></i>
          </Col>
          <Col>Show Archive</Col>
        </Row>
      </Menu.Item>
    </Menu>
  );
  return (
    <div className="task-property PrivateLibrary">
      <p className="right-title">
        <span>Private Library </span>
        <Dropdown overlay={settingMenu} trigger={["click"]}>
          <i className="fa-solid fa-gear"></i>
        </Dropdown>
      </p>

      <List
        className="demo-loadmore-list"
        itemLayout="horizontal"
        dataSource={listData}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Dropdown overlay={menu} trigger={["click"]}>
                <Button style={{ border: "none" }}>
                  <i className="fa-solid fa-ellipsis"></i>
                </Button>
              </Dropdown>,
              <i className="fa-solid fa-table-list"></i>,
              <i className="fa-solid fa-chart-bar"></i>,
            ]}
          >
            <NavLink to={`/tasks/library/privateLibraryItemPage/${item.title}`}>
              <Row gutter={[24, 0]} className="folder-title" align="middle">
                <Col>
                  <i
                    className={item.icon}
                    style={{
                      fontSize: "18px",
                      color: item.color,
                    }}
                  ></i>
                </Col>
                <Col>
                  <span style={{ fontSize: "17px" }}>{item.title}</span>
                </Col>
              </Row>
            </NavLink>
          </List.Item>
        )}
      />
      <Popover
        placement="topLeft"
        title="Create"
        content={content}
        trigger="click"
      >
        <Row gutter={[16, 0]} className="add-new">
          <Col>
            <i className="fa-solid fa-plus"></i>
          </Col>
          <Col>
            <span>New</span>
          </Col>
        </Row>
      </Popover>
    </div>
  );
}

export default PrivateLibrary;
